import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MomentModule } from 'ngx-moment';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination"
import { TimepickerModule } from 'ngx-bootstrap/timepicker'

import {
    MasterIndexComponent,

    CompanyListComponent,
    CompanyEntityComponent,

    MinesiteListComponent,
    MinesiteEntityComponent,

    ModelListComponent,
    ModelEntityComponent,

    PoweredByEntityComponent,

    EquipmentEntityComponent,

    CompanyFilterComponent,
    MinesiteFilterComponent,
    EquipmentFilterComponent,

    ModelManipulateComponent,
    ModelDetailsComponent,
    EquipmentManipulateComponent,
    EquipmentDetailsComponent,

    AttributeEditComponent,

    DocumentIndexComponent,
    DocumentListComponent,
    DocumentFilterComponent,
    DocumentHistoryComponent,

    PresetEntityComponent,
    PresetListComponent,
    PresetFilterComponent,
    PresetAssociationIndexComponent,

    DocumentAssociationIndexComponent,
    RecommendedComponent,
    DocumentSelectionComponent,
    AdvancedDocumentFilterComponent,

    StagedTabComponent,
    LiveTabComponent,
    StagingTabsComponent,
    ProjectListComponent,
    SnapshotListComponent,
    AssociationRouting
} from './index';

import { SharedModule } from './../shared/shared.module';


@NgModule({
    imports: [
        CommonModule,
        MomentModule,
        PaginationModule.forRoot(),
        FormsModule,

        SharedModule,

        AssociationRouting,

        ModalModule.forRoot(),
        DragDropModule
    ],
    declarations: [
        MasterIndexComponent,

        CompanyListComponent,
        CompanyEntityComponent,

        MinesiteListComponent,
        MinesiteEntityComponent,

        PresetListComponent,
        PresetEntityComponent,

        ModelListComponent,
        ModelEntityComponent,

        PoweredByEntityComponent,

        EquipmentEntityComponent,

        CompanyFilterComponent,
        MinesiteFilterComponent,
        EquipmentFilterComponent,

        ModelManipulateComponent,
        ModelDetailsComponent,
        EquipmentManipulateComponent,
        EquipmentDetailsComponent,

        AttributeEditComponent,

        DocumentIndexComponent,
        DocumentListComponent,
        DocumentFilterComponent,
        DocumentHistoryComponent,
        DocumentSelectionComponent,
        AdvancedDocumentFilterComponent,

        PresetAssociationIndexComponent,
        PresetFilterComponent,
        DocumentAssociationIndexComponent,
        RecommendedComponent,

        StagedTabComponent,
        LiveTabComponent,
        StagingTabsComponent,
        ProjectListComponent,
        SnapshotListComponent
    ]
})
export class AssociationModule { }
